import { Endpoints } from '../../../common/model/config';

export const stagingEndpoints: Endpoints = {
  api: 'https://api.staging.onyo.com/',
  graphql: 'https://graphql.staging.onyo.com/graphql',
  gsBucket: 'https://onyo-backend-staging.storage.googleapis.com/',
  s3Bucket: 'https://onyo.s3.amazonaws.com/',
  econboarding: 'https://api-stg.pedepronto.com.br/',
};
